import Form from 'components/Form';

import { IFormValues, IFormRegister, IFormWatch } from 'routes/Main/type';

import RowContainer from '../components/RowContainer';
import RowContent from './components/RowContentNowrap';

import SectionTitle from '../components/SectionTitle';
import MuiCheckbox from './components/CheckboxFallingType';
import MuiCheckboxTwo from './components/CheckboxFallingTypeTwo';
import MuiRadio from './components/MuiRadioFallingType';
import MuiRadioFallingTwo from './components/MuiRadioFallingTwo';
import { Grid, Stack } from '@mui/material';

interface Props extends IFormValues, IFormRegister, IFormWatch {
  disabled?: boolean;
}

const factors1 = [
  {
    label: 'Dáng đi không vững',
    value: 'falling_type.patient_risk_factors.check01',
  },
  {
    label: 'Mất thăng bằng',
    value: 'falling_type.patient_risk_factors.check02',
  },
  {
    label: 'Khiếm thị',
    value: 'falling_type.patient_risk_factors.check03',
  },
  {
    label: 'Nhu cầu tiểu tiện và đại tiện',
    value: 'falling_type.patient_risk_factors.check04',
  },
];

const factors2 = [
  {
    label: 'Ánh sáng',
    value: 'falling_type.patient_risk_factors.check05',
  },
  {
    label: 'Sàn nhà',
    value: 'falling_type.patient_risk_factors.check06',
  },
  {
    label: 'Khu vực lộn xộn',
    value: 'falling_type.patient_risk_factors.check07',
  },
  {
    label: 'Cần vật dụng ngoài tầm với',
    value: 'falling_type.patient_risk_factors.check08',
  },
];

const factors3 = [
  {
    label: 'Khác',
    value: 'falling_type.patient_risk_factors.check09',
  },
];

const physical1 = [
  {
    label: 'Không có',
    value: 'falling_type.patient_risk_factors_two.check01',
  },
  {
    label: 'Đau',
    value: 'falling_type.patient_risk_factors_two.check02',
  },
  {
    label: 'Bầm dập',
    value: 'falling_type.patient_risk_factors_two.check03',
  },
  {
    label: 'Xuất huyết',
    value: 'falling_type.patient_risk_factors_two.check04',
  },
  {
    label: 'Trầy xước',
    value: 'falling_type.patient_risk_factors_two.check05',
  },
];

const physical2 = [
  {
    label: 'Rách da',
    value: 'falling_type.patient_risk_factors_two.check06',
  },
  {
    label: 'Bong gân',
    value: 'falling_type.patient_risk_factors_two.check07',
  },
  {
    label: 'Trật khớp',
    value: 'falling_type.patient_risk_factors_two.check08',
  },
  {
    label: 'gãy xương',
    value: 'falling_type.patient_risk_factors_two.check09',
  },
  {
    label: 'Khác',
    value: 'falling_type.patient_risk_factors_two.check10',
  },
];

const FallingType = (props: Props) => {
  const { disabled, getValues, setValue, register } = props;

  return (
    <>
      <SectionTitle title="Phân loại sự cố - Ngã hoặc chấn thương" />
      <RowContainer xs={12}>
        <RowContent title="Mức độ ý thức" titleRatio={2} childrenRatio={10}>
          <MuiRadio
            i18nKey="SAFETY.TYPE.CONSCIOUSNESS.LEVEL"
            values={[1, 2, 3, 4, 5]}
            disabled={disabled}
            defaultValue={getValues('falling_type.consciousness_level')}
            onChange={v => setValue('falling_type.consciousness_level', v)}
            width="auto"
          />
        </RowContent>
        <RowContent title="Ambulation" titleRatio={2} childrenRatio={10}>
          <MuiRadioFallingTwo
            i18nKey="SAFETY.TYPE.ACTIVITY.STATUS"
            values={[1, 2, 3, 4]}
            disabled={disabled}
            defaultValue={getValues('falling_type.activity_status')}
            onChange={v => setValue('falling_type.activity_status', v)}
            width="auto"
          />
        </RowContent>
        <RowContent
          title="Địa điểm xảy ra sự cố"
          titleRatio={2}
          childrenRatio={10}
        >
          <Stack direction="row" spacing={3}>
            <MuiRadio
              i18nKey="SAFETY.TYPE.PLACE.FALLING.ACCIDENT"
              values={[1, 2, 3, 4, 0]}
              disabled={disabled}
              defaultValue={getValues('falling_type.place_falling_accident')}
              onChange={v => setValue('falling_type.place_falling_accident', v)}
              width="auto"
            />
            <Form.MuiTextField
              required={false}
              fullWidth
              disabled={disabled}
              placeholder="Nhập"
              {...register('falling_type.place_falling_accident_etc')}
            />
          </Stack>
        </RowContent>
        <RowContent
          title="Các yếu tố dẫn đến sự cố"
          titleRatio={2}
          childrenRatio={10}
        >
          <Stack direction="row" spacing={1} sx={{}}>
            {factors1.map((v, i) => {
              return (
                <Grid item xs={1.7}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={
                        Boolean(getValues(v.value)) ? [v.label] : []
                      }
                      onChange={(_, checked) => {
                        setValue(v.value, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={2} childrenRatio={10}>
          <Stack direction="row" spacing={1}>
            {factors2.map((v, i) => {
              return (
                <Grid item xs={1.68}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={
                        Boolean(getValues(v.value)) ? [v.label] : []
                      }
                      onChange={(_, checked) => {
                        setValue(v.value, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={2} childrenRatio={10}>
          <Stack direction="row" spacing={1}>
            {factors3.map((v, i) => {
              return (
                <Grid item xs={0.7}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={
                        Boolean(getValues(v.value)) ? [v.label] : []
                      }
                      onChange={(_, checked) => {
                        setValue(v.value, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
            <Form.MuiTextField
              required={false}
              fullWidth={false}
              disabled={disabled}
              placeholder="Enter"
              {...register('falling_type.fall_type')}
            />
          </Stack>
        </RowContent>

        <RowContent
          title="Chấn thương vật lý"
          titleRatio={2}
          childrenRatio={10}
        >
          <Stack direction="row" spacing={1}>
            {physical1.map((v, i) => {
              return (
                <Grid item xs={1.68}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={
                        Boolean(getValues(v.value)) ? [v.label] : []
                      }
                      onChange={(_, checked) => {
                        setValue(v.value, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
          </Stack>
        </RowContent>
        <RowContent title="" titleRatio={2} childrenRatio={10}>
          <Stack direction="row" spacing={1}>
            {physical2.map((v, i) => {
              return (
                <Grid item xs={i === 4 ? 0.7 : 1.68}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={
                        Boolean(getValues(v.value)) ? [v.label] : []
                      }
                      onChange={(_, checked) => {
                        setValue(v.value, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
            <Form.MuiTextField
              required={false}
              fullWidth={false}
              disabled={disabled}
              placeholder="Enter"
              {...register('falling_type.risk_factor_etc')}
            />
          </Stack>
        </RowContent>
      </RowContainer>
    </>
  );
};

export default FallingType;
